import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from "../../../components/UI/Table/Table";
import { Col, Card, CardBody } from 'reactstrap';
import { getAnalystsList, deleteAnalyst } from './action';
import { Preloading } from '../../../components/UI/Preloader/action';
import { setPageView, goolgeAnalyticsEvents } from '../../../components/GoogleAnalytics/index';

class AnalystListComponent extends Component {

    componentDidMount() {
        setPageView('/Analyst/List', document.location.href);
        this.props.getAnalystsList();
        this.props.preloading(true);
    }

    componentDidUpdate(prevProps) {
        if (this.props.analystsList !== prevProps.analystsList) {
            // Analyst list loaded successfully
            this.props.preloading(false);
        }
    }

    deleteAnalysts = (analystid, analystfirstname, analystlastname) => {
        let yes = window.confirm("Are you sure you want to delete \"" + analystfirstname + " " + analystlastname + "\" ?");
        if (yes) {
            this.props.preloading(true);
            this.props.deleteAnalyst(analystid);
            goolgeAnalyticsEvents('Admin', 'Delete Analyst', 'Delete', '')
        }
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Analysts Onboarded</h4>
                </div>
                <Card>
                    <CardBody>
                        <Table
                            data={Array.isArray(this.props.analystsList) ? this.props.analystsList : []}
                            noDataText="No user exists with assigned role as analyst "
                            columns={
                                [
                                    {
                                        Header: "First Name",
                                        id: "firstName",
                                        accessor: "firstname",
                                        className: 'center',
                                    },
                                    {
                                        Header: "Last Name",
                                        id: "lastName",
                                        accessor: "lastname",
                                        className: 'center',
                                    },
                                    {
                                        Header: "Email",
                                        id: "emailId",
                                        accessor: "email",
                                        className: 'center'
                                    },
                                    {
                                        Header: "Action",
                                        id: "delete",
                                        accessor: p => <button onClick={() => this.deleteAnalysts(p.id, p.firstname, p.lastname)} className="btn p-0 btn-transparent"><i id={p.id} className="icon-delete text-primary"></i></button>,
                                        className: 'center'
                                    }

                                ]
                            }
                            defaultPageSize={10}
                        />
                    </CardBody>
                </Card>
            </Col>

        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        analystsList: state.analystsList.analystsListSuccess
    }
}

const mapDispatchToProps = (dispatch, props) => ({
    getAnalystsList: () => dispatch(getAnalystsList()),
    deleteAnalyst: (id) => dispatch(deleteAnalyst(id)),
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AnalystListComponent);
